<template>
	<div class="default-layout">
		<MainMenu/>
		<transition name="header" mode="out-in" appear>
			<header class="header" :key="$route.path">
				<div class="container">
					<div class="content">
						<div class="top">
								<router-link :to="{name: 'home'}" id="logo" :key="$route.path">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 60"><path class="A" d="M264 0H31.2c-16.6 0-30 13.4-30 30s13.4 30 30 30h196c2.6-.1 5-1.4 6.4-3.6L266 3.6s2.2-3.6-2-3.6z"/><path class="B" d="M55.5 27.7H33.1l-4.6 4.6h10.9c-1.3 4.7-6.1 7.5-10.9 6.3-4.7-1.3-7.5-6.1-6.3-10.9 1.3-4.7 6.1-7.5 10.9-6.3 1.5.4 2.9 1.2 4 2.3l3.3-3.3a13.46 13.46 0 0 0-19.1 0 13.46 13.46 0 0 0 0 19.1 13.46 13.46 0 0 0 19.1 0c2-2 3.3-4.5 3.8-7.2h6.7c-1.3 11-11.2 18.9-22.2 17.7-11-1.3-18.9-11.2-17.7-22.2 1.3-11 11.2-18.9 22.2-17.7 4.5.5 8.7 2.5 11.9 5.7l3.3-3.3c-9.6-9.6-25.3-9.6-34.9 0s-9.6 25.3 0 34.9 25.2 9.7 34.9 0c4.6-4.6 7.2-10.9 7.2-17.5v-2.2zm18 8.8h-3.7v18.3h-6.2V17.4c0-6.4 3.7-10.1 9.9-10.1s9.9 3.7 9.9 10.1v8.9c.1 6.2-2.8 10.2-9.9 10.2zm3.8-18.8c0-3.3-1.4-4.8-3.7-4.8s-3.7 1.5-3.7 4.8v13.1h3.7c2.6 0 3.8-1.9 3.8-4.8v-8.3zm20.2 37.7c-6.2 0-10.1-3.7-10.1-10.1V17.4c0-6.4 3.9-10.1 10.1-10.1s10.1 3.7 10.1 10.1v27.9c0 6.4-3.9 10.1-10.1 10.1zm3.9-37.7c0-3.3-1.6-4.8-3.9-4.8s-3.9 1.5-3.9 4.8V45c0 3.3 1.6 4.8 3.9 4.8s3.9-1.5 3.9-4.8V17.7zm24.9 37.1V39c0-3-1.2-4.8-3.8-4.8h-3.4v20.7h-6.2V17.4c0-6.4 3.7-10.1 9.9-10.1s9.7 3.7 9.7 10.1v6.8c0 3.2-1.7 5.9-3.9 7.1 2.6 1.1 3.9 4.2 3.9 7.8v15.8h-6.2zm0-37.1c0-3.3-1.2-4.8-3.5-4.8s-3.7 1.5-3.7 4.8V29h3.4c2.6 0 3.8-1.9 3.8-4.8v-6.5zm21.6-4.1v41.3h-6.2V13.6h-6.8V7.9h19.7v5.7h-6.7zm23 41.2V37h-7.2v17.9h-6.2V17.4c0-6.2 3.6-10.1 9.8-10.1s9.8 3.9 9.8 10.1v37.4h-6.2zm0-37.1c0-3.2-1.3-4.8-3.6-4.8s-3.6 1.7-3.6 4.8v13.6h7.2V17.7zm21.7 37.1c-7.1 0-9.9-4-9.9-10.2V7.9h6.2v36.4c0 3 1.2 4.8 3.8 4.8h5.4v5.8h-5.5z"/></svg>
								</router-link>
							<span @click="$store.dispatch('openMenu')" id="menu" class="link-icon" tabindex="0">
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path class="A" d="M0 0h24v24H0z"/><path class="B" d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>
							</span>
						</div>
					</div>
				</div>
			</header>
		</transition>
		<transition name="fade" mode="out-in" appear>
			<slot/>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src
import MainMenu from '@/components/MainMenu.vue'

export default {
	components: {
		MainMenu
	},
}
</script>

<style>
.default-layout {
	position: relative;
	display: flex;
	flex-direction: column;
	background-color: var(--body_background_color);
	overflow: auto;
	height: 100%;
}

.default-layout .header {
	padding: 1.6rem 0;
	background-color: #fff;
	color: var(--primary_text_color);
	flex-shrink: 0;
	transition: all .4s;
	max-height: 72.0rem;
}

.default-layout .header:not(#home-header) {
	position: sticky;
	top: 0;
	z-index: 100;
	box-shadow: 0 0 .2rem rgba(0,0,0,0.5);	
}

.default-layout .header .top {
	display: flex;
	justify-content: space-between;
}

.default-layout .header path {
	fill: var(--primary_text_color);
	transition: all .4s;
}

.default-layout .header #logo {
	display: flex;
	padding: .4rem 0;
}

.default-layout .header #logo svg {
	width: auto;
	height: 4.8rem;
	max-height: 3.2rem;
	transition: all .4s;
}

.default-layout .header #logo .C {
	fill: var(--primary_text_color);
}

.default-layout .header #logo .A {
	fill: var(--primary_color);
}

.default-layout .header #logo .B {
	fill: var(--inverse_text_color);
}

.default-layout .header #menu svg {
	width: 100%;
	height: 100%;
}

.default-layout .header #menu .A {
	fill: none;
}

.default-layout .header .link-icon {
	width: 4.0rem;
	height: 4.0rem;
}

.default-layout .header,
.default-layout .header .container,
.default-layout .header .container .content {
	display: flex;
	flex-direction: column;
}

.default-layout .header .container,
.default-layout .header .container .content {
	flex-grow: 1;
}

.default-layout #home-header .credits .credits-link {
	background: var(--primary_color);
	color: var(--inverse_text_color);
	border-radius: .3rem;
	padding: 0 .3rem;
}

.default-layout .main {
	padding: 1.6rem 0;
}

.default-layout #navigation {
	padding: 1.6rem 0;
	background-color: var(--primary_color);
	color: var(--inverse_text_color);
	font-size: 2.4rem;
	line-height: 4.0rem;
}

.default-layout #navigation a {
	color: var(--inverse_text_color);
}

.default-layout #navigation .dot-menu .dot-menu-handler {
	width: 4.0rem !important;
	height: 4.0rem !important;
}

.default-layout #navigation .dot-menu .dot-menu-handler-icon path {
	fill: var(--inverse_text_color);
}

.default-layout #navigation .container {
	/*overflow: hidden;*/
}

.default-layout #navigation .flex {
	display: flex;
	align-items: center;
}

.default-layout #navigation .go-back {
	margin-right: .8rem;
	cursor: pointer;
}

.default-layout #navigation .navigation-icon {
	display: block;
	width: 4.0rem;
	height: 4.0rem;
}

.default-layout .navigation-icon.left {
	margin-right: .8rem;
}

.default-layout #navigation .navigation-icon.small {
	padding: .8rem;
}

.default-layout #navigation .navigation-icon path {
	fill: var(--inverse_text_color);
}

.default-layout #navigation .navigation-right {
	margin-left: auto;
}

.default-layout .page {
	position: relative;
	display: flex;
	flex-direction: column;
	flex-grow: 1;
}

</style>